module.exports = __webpack_public_path__ + "img/natural-paper-texture.b163fa74.jpg";